import React, {useEffect, useState } from "react";
import ReactHtmlParser from 'react-html-parser';

const Description = ({ des }) => {
  const [showMore, setShowMore] = useState(false);
  const toggleShowMore = () => {
    setShowMore(!showMore);
    if(showMore){
      window.scrollTo(0,700)
    }
  }

  return (
    <>
      <div className="description">
        {showMore ? ReactHtmlParser(des) : ReactHtmlParser(des.substring(0, 600))}
      </div>
      {des.length > 600 && (
        <div className="container-detail-button">
          <div onClick={toggleShowMore}>
            <i className={showMore ? "fa fa-angle-up pdr-5" : "fa fa-angle-down pdr-5"}></i>
            {showMore ? "THU NHỎ" : "XEM THÊM"}
          </div>
        </div>
      )}
    </>
  );
}


const DescriptionV1 = ({ des }) => {
  const [showMore, setShowMore] = useState(false);
  useEffect(()=>{
    if(des.length < 600){
      setShowMore(!showMore);
    }
  },[]);
  const toggleShowMore = () => {
    setShowMore(!showMore);
    if(showMore){
      window.scrollTo(0,700)
    }
  }

  return (
    <>
      <div className={showMore ? "row description_full":"row description_product"}>
        <div className="col-12">
          {showMore ? ReactHtmlParser(des) : ReactHtmlParser(des.substring(0, 2000))}
        </div>

        {des.length > 400 && (
        <div className="see_more z-1 col-12 text-center">
                <button onClick={toggleShowMore}>
                  {showMore ? "Thu gọn" : "Xem thêm"}
              </button>
          </div>
        )}
      </div>
    </>
  );
}

export {Description, DescriptionV1} ;

